import Reflux from 'reflux';

const CollectorsActions = Reflux.createActions({
  list: { asyncResult: true },
  getCollector: { asyncResult: true },
});

export default CollectorsActions;



// WEBPACK FOOTER //
// ./src/web/collectors/CollectorsActions.js